import { graphql } from '@api/generated';
import { getClient } from '@api/client';
import { CallReason } from '@api/generated/graphql';

export const getCallReasonsQuery = graphql(`
  query callReasons($tenantId: ID!, $skip: Int, $take: Int) {
    callReasons(tenantId: $tenantId, skip: $skip, take: $take) {
      items {
        id
        name
        isLead
        active
        tenantId
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`);

export type FetchedCallReason = Omit<
  CallReason,
  'updatedAt' | 'createdAt' | 'tenant' | 'tenantId'
>;

export const fetchCallReasons = async (
  tenantId: string,
  search?: {
    skip?: number;
    take?: number;
  },
): Promise<FetchedCallReason[]> => {
  const { data, error } = await getClient().query({
    query: getCallReasonsQuery,
    variables: { tenantId, skip: search?.skip, take: search?.take },
  });

  if (error) {
    throw new Error(error.message);
  }

  return data?.callReasons?.items ?? [];
};
